import type { ReactNode } from "react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { ErrorPanel } from "@/components/Errors/ErrorPanel";
import { IconAirplaneCrossed, IconHotelCrossed } from "@/components/Icons";

type Props = {
  scope: "flights" | "hotels";
  title: ReactNode;
  onClearFilterClick: () => void;
};

export const NoFilteringResults = ({
  scope,
  title,
  onClearFilterClick,
}: Props) => {
  const intl = useIntl();

  return (
    <ErrorPanel
      icon={scope === "flights" ? IconAirplaneCrossed : IconHotelCrossed}
      primaryText={title}
      secondaryText={intl.formatMessage({
        defaultMessage: "Try adjusting or clearing them to see more options",
        description: "tryAdjustingFilter",
      })}
    >
      <Button
        onClick={onClearFilterClick}
        variant="outlined"
        borderRoundness="medium"
        color="primary"
        size="small"
      >
        {intl.formatMessage({
          defaultMessage: "Clear filter",
          description: "clearFilter",
        })}
      </Button>
    </ErrorPanel>
  );
};
